import { calendarDateFromStorage, isCalendarDate } from './calendar-date'

/** Server calendar metadata is optional while clients and API roll out separately. */
export interface RetainerCalendar {
  timezone: string
  today: string
}

/** Labels compare calendar boundaries, never a device-local clock or UTC instant. */
export function retainerPeriodPosition(
  periodStart: Date | string,
  currentPeriodStart?: Date | string | null,
): 'current' | 'upcoming' | 'past' | null {
  const start = calendarDateFromStorage(periodStart)
  const current = calendarDateFromStorage(currentPeriodStart)
  if (!start || !current) return null
  return start === current ? 'current' : start > current ? 'upcoming' : 'past'
}

/** One refresh identity per scope/business day; failed reads must not spin. */
export function retainerCalendarRefreshKey(
  scope: string,
  calendar: Partial<RetainerCalendar> | undefined,
  today: string,
): string | null {
  if (
    !calendar ||
    typeof calendar.timezone !== 'string' ||
    !isCalendarDate(calendar.today) ||
    !isCalendarDate(today) ||
    calendar.today === today
  )
    return null
  return JSON.stringify([scope, calendar.timezone, today])
}
